import { createAction } from 'redux-actions';
import { CALL_SERVICE } from '@instructure/redux-service-middleware';
import { SET_ALIGNMENTS, VIEW_ALIGNMENT, CLOSE_ALIGNMENT, UPDATE_ALIGNMENT, SET_LAUNCH_CONTEXTS } from "../../constants.js";
import { getAlignedOutcomeIds, getAlignedOutcome, getOutcomeAlignmentSetId, getLaunchContextUuid, isLaunchingFromRootAccount } from "./selectors.js";
import { getConfig } from "../config/selectors.js";
import { setError } from "../context/actions.js";
import { loadSelectedLaunchContext } from "../OutcomePicker/actions.js";
/*
 * action creators
 */
export var setLaunchContexts = createAction(SET_LAUNCH_CONTEXTS);
export var setAlignments = createAction(SET_ALIGNMENTS);
export var viewAlignmentAction = createAction(VIEW_ALIGNMENT);
export var closeAlignment = createAction(CLOSE_ALIGNMENT);
export var updateAlignment = createAction(UPDATE_ALIGNMENT);
export var loadLaunchContexts = function loadLaunchContexts(launchContexts) {
  return function (dispatch, _getState) {
    return dispatch(setLaunchContexts(launchContexts));
  };
};
export var viewAlignment = function viewAlignment(outcomeId) {
  return function (dispatch, getState, _arg, scope) {
    var outcome = getAlignedOutcome(getState(), scope, outcomeId);
    dispatch(viewAlignmentAction(outcomeId));
    if (outcome && outcome.scoring_method) {
      return Promise.resolve();
    }
    var _getConfig = getConfig(getState(), scope),
      host = _getConfig.host,
      jwt = _getConfig.jwt,
      contextUuid = _getConfig.contextUuid;
    return dispatch({
      type: CALL_SERVICE,
      payload: {
        service: 'outcomes',
        method: 'getOutcome',
        args: [host, jwt, outcomeId, contextUuid]
      }
    }).then(function (json) {
      return dispatch(updateAlignment({
        outcome: json
      }));
    });
  };
};
export var updateAlignments = function updateAlignments(guid, outcomes, updateCallback) {
  return function (dispatch) {
    dispatch(setAlignments({
      guid: guid,
      outcomes: outcomes
    }));
    if (updateCallback) {
      updateCallback({
        guid: guid,
        outcomes: outcomes
      });
    }
    return Promise.resolve();
  };
};
export var loadAlignments = function loadAlignments(alignmentSetId, launchContexts, updateCallback) {
  return function (dispatch, getState, _arg, scope) {
    if (alignmentSetId && getOutcomeAlignmentSetId(getState(), scope) === alignmentSetId) {
      return Promise.resolve();
    }
    if (launchContexts && launchContexts.length > 0) {
      dispatch(loadLaunchContexts(launchContexts));
      dispatch(loadSelectedLaunchContext());
    }
    var _getConfig2 = getConfig(getState(), scope),
      host = _getConfig2.host,
      jwt = _getConfig2.jwt,
      contextUuid = _getConfig2.contextUuid;
    var launchContext = getLaunchContextUuid(getState(), scope);
    var launchingFromRoot = isLaunchingFromRootAccount(getState(), scope);
    return dispatch(clearAlignmentSet()).then(function () {
      return dispatch({
        type: CALL_SERVICE,
        payload: {
          service: 'outcomes',
          method: 'getAlignments',
          args: [host, jwt, alignmentSetId, contextUuid, launchContext, launchingFromRoot]
        }
      });
    }).then(function (json) {
      return dispatch(updateAlignments(json.guid, json.outcomes, updateCallback));
    }).catch(function (e) {
      return dispatch(setError(e));
    });
  };
};
export var removeAlignment = function removeAlignment(alignmentId, updateCallback) {
  var shouldUpdateArtifact = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  return function (dispatch, getState, _arg, scope) {
    var newIds = getAlignedOutcomeIds(getState(), scope).filter(function (id) {
      return id !== alignmentId;
    });
    if (newIds.length === 0 && !shouldUpdateArtifact) {
      return dispatch(clearAlignmentSet(updateCallback));
    }
    var updateAlignmentFunc = shouldUpdateArtifact ? upsertArtifact : createAlignmentSet;
    return dispatch(updateAlignmentFunc(newIds)).then(function (response) {
      if (shouldUpdateArtifact) {
        var newOutcomes = newIds.map(function (id) {
          return getAlignedOutcome(getState(), scope, id);
        });
        return dispatch(updateAlignments(response.guid, newOutcomes, updateCallback));
      }
      return dispatch(updateAlignments(response.guid, response.outcomes, updateCallback));
    }).catch(function (e) {
      return dispatch(setError(e));
    });
  };
};
export var createAlignmentSet = function createAlignmentSet(outcomeIds) {
  return function (dispatch, getState, _arg, scope) {
    var _getConfig3 = getConfig(getState(), scope),
      host = _getConfig3.host,
      jwt = _getConfig3.jwt;
    var launchContext = getLaunchContextUuid(getState(), scope);
    var launchingFromRoot = isLaunchingFromRootAccount(getState(), scope);
    return dispatch({
      type: CALL_SERVICE,
      payload: {
        service: 'outcomes',
        method: 'createAlignmentSet',
        args: [host, jwt, outcomeIds, launchContext, launchingFromRoot]
      }
    });
  };
};
export var clearAlignmentSet = function clearAlignmentSet(updateCallback) {
  return function (dispatch) {
    dispatch(updateAlignments(null, [], updateCallback));
    return Promise.resolve();
  };
};
export var loadArtifact = function loadArtifact() {
  return function (dispatch, getState, _arg, scope) {
    var _getConfig4 = getConfig(getState(), scope),
      host = _getConfig4.host,
      jwt = _getConfig4.jwt,
      artifactType = _getConfig4.artifactType,
      artifactId = _getConfig4.artifactId;
    return dispatch(clearAlignmentSet()).then(function () {
      return dispatch({
        type: CALL_SERVICE,
        payload: {
          service: 'outcomes',
          method: 'getArtifact',
          args: [host, jwt, artifactType, artifactId]
        }
      });
    }).then(function (json) {
      return dispatch(updateAlignments(json.guid, json.outcomes));
    }).catch(function (e) {
      return dispatch(setError(e));
    });
  };
};
export var upsertArtifact = function upsertArtifact(outcomeIds) {
  return function (dispatch, getState, _arg, scope) {
    var _getConfig5 = getConfig(getState(), scope),
      host = _getConfig5.host,
      jwt = _getConfig5.jwt,
      artifactType = _getConfig5.artifactType,
      artifactId = _getConfig5.artifactId,
      contextUuid = _getConfig5.contextUuid;
    return dispatch({
      type: CALL_SERVICE,
      payload: {
        service: 'outcomes',
        method: 'upsertArtifact',
        args: [host, jwt, artifactType, artifactId, contextUuid, outcomeIds]
      }
    });
  };
};